module.exports = __webpack_public_path__ + "img/google_Play.ab8d80a0.svg";